// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"204":"a5492c459816d198c6ec","237":"918bb673f1c8f9c309c2"}[chunkId] + ".js";
};